"use client";

import React, { useState } from "react";

import { useAdressesFromGouv } from "@/hooks/useAdressesFromGouv";
import { useClubsFiltersAdressesStore } from "@/stores/clubs-filters-store";

export interface AddressFeature {
  type: "Feature";
  geometry: {
    type: "Point";
    coordinates: [number, number];
  };
  properties: {
    label: string;
    name: string;
    postcode: string;
    city: string;
    street?: string;
    [key: string]: any;
  };
}

interface AddressAutocompleteInputProps {
  value: string;
  onChange: (value: string) => void;
  onSelect: (feature: AddressFeature) => void;
  disabled?: boolean;
  placeholder?: string;
  label?: string;
}

const AddressAutocompleteInput = ({
  value,
  onChange,
  onSelect,
  disabled = false,
  placeholder = "Rechercher une adresse...",
  label,
}: AddressAutocompleteInputProps) => {
  const [showSuggestions, setShowSuggestions] = useState(false);
  const { fetchAdresses } = useAdressesFromGouv();
  const adresses = useClubsFiltersAdressesStore((state) => state.adresses);

  const handleChange = async (newValue: string) => {
    onChange(newValue);
    if (!newValue || newValue.length < 3) {
      setShowSuggestions(false);
      return;
    }
    await fetchAdresses(newValue);
    setShowSuggestions(true);
  };

  const handleSelect = (feature: AddressFeature) => {
    onChange(feature.properties.label);
    setShowSuggestions(false);
    onSelect(feature);
  };

  return (
    <div className="w-full relative">
      {label && <label className="text-md font-bold">{label}</label>}
      <div className="flex mt-1 border items-center h-[48px] rounded-md border-dark-grey relative">
        <input
          type="text"
          value={value}
          onChange={(e) => handleChange(e.target.value)}
          onBlur={() => setTimeout(() => setShowSuggestions(false), 150)}
          placeholder={placeholder}
          disabled={disabled}
          className="w-full bg-transparent placeholder:italic rounded-md pl-4 pr-1"
        />
      </div>
      {showSuggestions && adresses.length > 0 && (
        <ul className="absolute z-50 w-full bg-white border border-light-grey rounded-md shadow-md mt-1 max-h-48 overflow-y-auto">
          {adresses.map((feature, index) => (
            <li
              key={`${feature.properties.label}-${index}`}
              onMouseDown={() => handleSelect(feature as AddressFeature)}
              className="cursor-pointer px-4 py-2 text-sm border-b border-light-grey hover:bg-light-grey last:border-b-0"
            >
              {feature.properties.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AddressAutocompleteInput;
